const REPEATED = '@repeated';
/**
 * Fires an event for the given component.
 *
 * @param engineComponent - The component where the event should be fired;
 * @param event - The event to be fired.
 */
function fireComponentEvent(engineComponent, event) {
    const eventDelegator = engineComponent.getEventDelegator();
    eventDelegator.fire(event);
}
/**
 * Retrieves a component node based on the engine context and properties.
 *
 * @param props - Properties used to provide the component;
 * @param context - The context which should be used to find the component.
 */
function getEngineComponent(props, context) {
    return getRoot(context)
        .provideNode(props.uuid, getInstanceUUID(props, context), context.parent);
}
/**
 * Retrieves an instace UUID based on the engine context and properties.
 *
 * @param props - Properties used to provide the instance UUID;
 * @param context - The context which should be used to find the instance UUID.
 */
function getInstanceUUID(props, context) {
    const identifier = props[REPEATED]
        ? (props.identifier ?? '')
        : props.uuid;
    return `${context.parentInstanceUUID}_${identifier}`;
}
/**
 * Retrieves the root {@link FragmentNode} for the given engine context.
 *
 * @param context - The context from which the root belongs.
 */
function getRoot(context) {
    const root = context.root;
    if (!root) {
        throw new Error('[React Bridge]: Missing Root');
    }
    return root;
}
export { fireComponentEvent, getEngineComponent, getInstanceUUID, getRoot, };
//# sourceMappingURL=bridge-commons.js.map